import { Component, OnDestroy, OnInit} from '@angular/core';
import { StatsService } from '../../../../shared/services/pubServices/stats.service';
import * as echarts from 'echarts/core';
import { MapChart } from 'echarts/charts';

@Component({
  selector: 'pub-anal-worldmap',
  templateUrl: './worldmap.html',
  styleUrls: ['./worldmap.scss']
})

export class analworldmapComponent implements OnInit, OnDestroy {
  option: any;
  worldData: any;
  max: any;
  idTime: any;
  countDown: number;

  constructor(private statsService: StatsService ) {
     echarts.use([MapChart]);
     this.countDown = 30;
   }

  ngOnInit() {
    this.readMap(data => {
      echarts.registerMap('world', data);
    });

    this.getLiveVisitors();

    this.idTime = setInterval(() => {
      this.countDown-=1;
      if(this.countDown==0)
        this.countDown=30;

      if(this.countDown==1)
      {
        this.getLiveVisitors();
      }
    }, 1000);
  }

  ngOnDestroy(){
    if (this.idTime) {
      clearInterval(this.idTime);
    }
  }

  getLiveVisitors(){
    this.statsService.getLiveVisitors()
    .subscribe(
     data => {
      this.worldData = data.data;
      console.log("MAP: ", this.worldData);
      this.max = Math.max.apply(Math, this.worldData.map(function(o) { return o.value; }));
      this.changeOption();
     },
     error => {
       console.log(error);
     });
  }

  readMap(cb) {
    const req = new XMLHttpRequest();
    req.open('GET', `assets/data/world.json`);
    req.onload = () => {
      cb(req.response);
    };
    req.send();
  }

  changeOption(){
    this.option = {
      title: {
        text: 'Number of live visitors within last 5min',
        textStyle:{
          width: 300,
          overflow: 'break'
        },
        left: 'center'
      },
      tooltip: {
        trigger: 'item',
        showDelay: 0,
        transitionDuration: 0.2
      },
      visualMap: {
        left: 'right',
        min: 1,
        max: this.max,
        inRange: {
          color: [
            '#313695',
            '#4575b4',
            '#74add1',
            '#abd9e9',
            '#e0f3f8',
            '#ffffbf',
            '#fee090',
            '#fdae61',
            '#f46d43',
            '#d73027',
            '#a50026'
          ]
        },
        text: ['High', 'Low'],
        calculable: true
      },
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'top',
        feature: {
          saveAsImage: {}
        }
      },
      series: [
        {
          name: 'Number of live visitors within last 5min',
          type: 'map',
          roam: true,
          map: 'world',
          label: {
            show: true,
            color: 'inherit',
            fontWeight: 'normal',
            formatter: function (param: any) {
              var ilosc = param.value;
              if(ilosc > 0)
                {return param.value}
              else
                return '';
              }
          },
          emphasis: {
            label: {
              show: true
            }
          },
          data: this.worldData
        }
      ]
    };
  }

  onUpdate(){
    this.getLiveVisitors();
  };

}
